<template>
  <div class="section-title section-title-internal">
    <div class="section-title-icon">
      <button @click="$router.go(-1)">
        <i class="icofont-reply"></i>
        <span>Voltar</span>
      </button>
    </div>
    <div class="section-title-info">
      <h4>{{ title }}</h4>
      <p>{{ description }}</p>
    </div>
    <div class="section-title-btn-help">
      <modal-informacao
        :isIframe="true"
        urlIframe="https://esus-feedback.gitbook.io/esus-feedback/indicadores-aps/saude-bucal/tratamentos-concluidos"
        pageIdentifier="tratamentos-concluidos"
      ></modal-informacao>
    </div>
  </div>
</template>

<script>
import ModalInformacao from '@/components/ModalInformacao.vue'
import { infoHtml } from '../utils.js'

export default {
  name: 'SectionTitle',
  components: {
    ModalInformacao,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
  },
  mounted() {},
  data() {
    return {
      text: infoHtml,
    }
  },
  methods: {},
}
</script>

<style></style>
